module.exports = __webpack_public_path__ + "static/img/illu_en_05.3c77d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_en_05.png
// module id = V0Gs
// module chunks = 1